import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import Navbar from '../../layout/Navbar/Navbar';
import Sidebar from '../../layout/Sidebar/SideBar';
import Loading from '../../components/Loading';


import blogFetch from '../../axios/config';
import './style.css';
import { HistoricoTelasI, Ordem, TipoTela } from './types';
import { InfoCard } from './InforCard';
import { Column, DataTable } from './DataTable';
import { CriarTelaModal } from './CriatTelaModal';
import { CriarModalOrdens } from './CriarModalOrdens';

const ordensColumns: Column<Ordem>[] = [
	{ key: 'ordem_Fabric', header: 'Ordem' },
	{ key: 'serial', header: 'Serial' },
	{ key: 'caracteristica_Resultado', header: 'Característica' }
];

const historicoColumns: Column<HistoricoTelasI>[] = [
	{ key: 'imp_Tela', header: 'Tela' },
	{ key: 'imp_Ordem', header: 'Ordem' },
	{ key: 'imp_CodLote', header: 'Lote' },
	{ key: 'imp_Status', header: 'Status' },
	{
		key: '_ts_Creat',
		header: 'Data',
		render: (item: HistoricoTelasI) => new Date(item._ts_Creat).toLocaleDateString()
	}
];

export default function Fotolito() {
	const [ordens, setOrdens] = useState<Ordem[]>([]);
	const [historicoTelas, setHistoricoTelas] = useState<HistoricoTelasI[]>([]);
	const [tipoTela, setTipoTela] = useState<TipoTela>('');
	const [quantidade, setQuantidade] = useState('');
	const [showModal, setShowModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [openModalOrdens, setOpenModalOrdens] = useState(false);
	const [ordensSoltas, setOrdensSoltas] = useState([])

	const user = useMemo(() => JSON.parse(localStorage.getItem('user') as string), []);

	const fetchData = useCallback(async () => {
		try {
			const { data } = await blogFetch.get<Ordem[]>("SAGA_ListaProducao/getOrdens");
			setOrdens(data);
		} catch (error) {
			console.error("Erro ao buscar ordens:", error);
		}
	}, []);

	const fetchHistorico = useCallback(async () => {
		try {
			const { data } = await blogFetch.get<HistoricoTelasI[]>(
				"SAGA_ListaProducao/getHistoricoTelas"
			);
			setHistoricoTelas(data);
		} catch (error) {
			console.error("Erro ao buscar histórico:", error);
		}
	}, []);

	const carregarTudo = useCallback(async () => {
		setIsLoading(true);
		try {
			await Promise.all([fetchData(), fetchHistorico()]);
		} finally {
			setIsLoading(false);
		}
	}, [fetchData, fetchHistorico]);

	useEffect(() => {
		carregarTudo();
	}, [carregarTudo]);

	const handleSubmit = useCallback((e: React.FormEvent) => {
		e.preventDefault();
		blogFetch.post(`SAGA_ListaProducao/criarImpressaoTelas?tipo=${tipoTela}`, user.user_UserName, {
			responseType: 'blob' // Isso informa ao Axios que a resposta é um blob
		})
			.then(response => {
				if (response.data) {
					const blob = new Blob([response.data]);
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = 'Telas.xlsx';
					document.body.appendChild(a);
					a.click();
					window.URL.revokeObjectURL(url);
					document.body.removeChild(a);
				}

				carregarTudo();
			})
			.catch(error => {
				console.error('Erro ao baixar o arquivo:', error);
			});

		setShowModal(false);
		setTipoTela('');
		setQuantidade('');
	}, [tipoTela, user, carregarTudo]);

	const openModalListaOrdens = useCallback(async () => {
		const { data } = await blogFetch.get('SAGA_ListaProducao/getOrdensSolta')
		setOrdensSoltas(data);
		setOpenModalOrdens(true)
	}, []);

	const handleReimprimir = useCallback((e: React.FormEvent) => {
		e.preventDefault()

		blogFetch.post(`SAGA_ListaProducao/ReimprimirOrdensSoltas`, ordensSoltas, {
			responseType: 'blob' // Isso informa ao Axios que a resposta é um blob
		})
			.then(response => {
				if (response.data) {
					const blob = new Blob([response.data]);
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = 'TelasSoltas.xlsx';
					document.body.appendChild(a);
					a.click();
					window.URL.revokeObjectURL(url);
					document.body.removeChild(a);
					setOrdensSoltas([])
					setOpenModalOrdens(false)
				}

				carregarTudo();
			})
			.catch(error => {
				console.error('Erro ao baixar o arquivo:', error);
			});
	}, [ordensSoltas, carregarTudo]);

	return (
		<>
			<Navbar />
			<Sidebar />
			<Container fluid className="app_body">
				{!isLoading ? (
					<>
						<div className="_telascard-container">

							<InfoCard
								title="Lista de Ordens"
								actionButton={<Button
									variant="primary"
									onClick={() => setShowModal(true)}
									className="generate-btn"
								>
									Gerar Tela
								</Button>
								}
							>
								<DataTable
									data={ordens}
									columns={ordensColumns}
									emptyMessage="Nenhuma ordem encontrada" />
							</InfoCard>

							<InfoCard title="Histórico de Telas" actionButton={<Button
								variant="primary"
								onClick={() => openModalListaOrdens()}
								className="generate-btn"
							>
								Telas Soltas
							</Button>
							} >

								<DataTable
									data={historicoTelas}
									columns={historicoColumns}
									emptyMessage="Nenhuma tela encontrada"
								/>
							</InfoCard>
							<CriarTelaModal
								show={showModal}
								onHide={() => setShowModal(false)}
								onSubmit={handleSubmit}
								tipoTela={tipoTela}
								setTipoTela={setTipoTela}
								quantidade={quantidade}
								setQuantidade={setQuantidade}
							/>

							<CriarModalOrdens
								show={openModalOrdens}
								onHide={() => setOpenModalOrdens(false)}
								onSubmit={handleReimprimir}
								ordensSoltas={ordensSoltas}
							/>
						</div>
					</>
				) : <Loading />}

			</Container>
		</>
	);
}
